import { render, staticRenderFns } from "./LD.vue?vue&type=template&id=007dba95&scoped=true"
import script from "./LD.vue?vue&type=script&lang=js"
export * from "./LD.vue?vue&type=script&lang=js"
import style0 from "./LD.vue?vue&type=style&index=0&id=007dba95&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007dba95",
  null
  
)

export default component.exports